export const reportsData = {
  1: {
    id: 1,
    assessmentTitle: 'Business Pulse Check',
    completedDate: '2024-01-15',
    overallScore: 78,
    summary: 'Your business shows strong foundations but requires focus on operational scalability and digital presence.',
    sections: [
      { title: 'Strategy & Vision', score: 85, status: 'Strong', feedback: 'Your long-term goals are well-defined.', recommendations: ['Review strategic KPIs monthly.', 'Develop a formal succession plan.'] },
      { title: 'Operations', score: 62, status: 'Needs Improvement', feedback: 'Manual processes are bottlenecks.', recommendations: ['Implement a central CRM.', 'Document SOPs.'] },
      { title: 'Financial Health', score: 82, status: 'Healthy', feedback: 'Cash flow management is robust.', recommendations: ['Explore investment options.', 'Optimize tax planning.'] },
      { title: 'Team & Culture', score: 75, status: 'Stable', feedback: 'High satisfaction, limited training.', recommendations: ['Introduce training budgets.', 'Peer-recognition program.'] }
    ]
  },
  2: {
    id: 2,
    assessmentTitle: 'Marketing Effectiveness Audit',
    completedDate: '2024-01-10',
    overallScore: 65,
    summary: 'Marketing efforts are consistent but lack data-driven attribution and ROI tracking.',
    sections: [
      { title: 'Brand Positioning', score: 70, status: 'Stable', feedback: 'Market awareness is good.', recommendations: ['Refresh website messaging.', 'Conduct competitor audit.'] },
      { title: 'Lead Generation', score: 55, status: 'Needs Improvement', feedback: 'High dependency on paid search.', recommendations: ['Invest in SEO.', 'Implement email automation.'] }
    ]
  },
  3: {
    id: 3,
    assessmentTitle: 'Financial Health Assessment',
    completedDate: '2024-01-05',
    overallScore: 82,
    summary: 'Excellent financial discipline with strong profitability margins.',
    sections: [
      { title: 'Profitability', score: 88, status: 'Exceptional', feedback: 'Margins are higher than average.', recommendations: ['Maintain cost-controls.', 'Analyze product-level profit.'] }
    ]
  },
  4: {
    id: 4,
    assessmentTitle: 'Business Pulse Check',
    completedDate: '2023-10-12',
    overallScore: 72,
    summary: 'Initial pulse check showing moderate stability with high operational risk.',
    sections: [
      { title: 'Strategy & Vision', score: 78, status: 'Stable', feedback: 'Goals exist but lack clarity.', recommendations: ['Define 3-year vision.', 'Set specific quarterly targets.'] },
      { title: 'Operations', score: 55, status: 'At Risk', feedback: 'Complete lack of documentation.', recommendations: ['Start process mapping.', 'Identify single points of failure.'] },
      { title: 'Financial Health', score: 80, status: 'Healthy', feedback: 'Good cash reserves.', recommendations: ['Establish emergency fund policies.'] },
      { title: 'Team & Culture', score: 68, status: 'Stable', feedback: 'Base engagement is okay.', recommendations: ['Conduct first team survey.'] }
    ]
  },
  5: {
    id: 5,
    assessmentTitle: 'Business Pulse Check',
    completedDate: '2023-06-20',
    overallScore: 64,
    summary: 'Baseline assessment. Foundational structures are being established.',
    sections: [
      { title: 'Strategy & Vision', score: 65, status: 'Developing', feedback: 'Ad-hoc strategic planning.', recommendations: ['Schedule first off-site.', 'Appoint strategy lead.'] },
      { title: 'Operations', score: 48, status: 'At Risk', feedback: 'Highly chaotic daily operations.', recommendations: ['Prioritize core process fixing.'] },
      { title: 'Financial Health', score: 75, status: 'Stable', feedback: 'Managing but tight.', recommendations: ['Review expenses weekly.'] },
      { title: 'Team & Culture', score: 60, status: 'Stable', feedback: 'Small team, high pressure.', recommendations: ['Define core values.'] }
    ]
  }
};